
import React, { useState } from 'react';
import ModuleEditor from '@/components/admin/course-builder/ModuleEditor';
import TaxonomyPathVisualizer from '@/components/admin/course-builder/TaxonomyPathVisualizer';
import { LearningModule } from '@/types/supabase';

const MentorCourseBuilder = () => {
  const [selectedModuleId, setSelectedModuleId] = useState<string | undefined>();

  const handleModuleSelected = (module: LearningModule) => {
    setSelectedModuleId(module.id);
  };

  const handleModuleCreated = (module: LearningModule) => {
    setSelectedModuleId(module.id);
  };

  return (
    <div className="container mx-auto py-6 space-y-6">
      <h1 className="text-2xl font-bold">Mentor Course Builder</h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <ModuleEditor 
            moduleId={selectedModuleId}
            onModuleSelected={handleModuleSelected}
            onModuleCreated={handleModuleCreated}
          />
        </div>
        <div>
          <TaxonomyPathVisualizer />
        </div>
      </div>
    </div>
  );
};

export default MentorCourseBuilder;
